<template>
  <div>
    <el-form v-if="openType === 1" style="margin: 20px 40px 0 0" :model="checkoutApplyForm" :rules="checkoutApplyRules" ref="checkoutApplyForm" label-width="120px" class="demo-ruleForm">
      <el-form-item label="原因" prop="reason">
        <el-select v-fixZoom v-model="checkoutApplyForm.reason" filterable placeholder="请选择" style="width: 100%">
          <el-option v-for="item in reasonArr" :key="item.id" :label="item.name" :value="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="">
        <el-input type="textarea" :rows="2" v-model="checkoutApplyForm.remark" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    <el-form v-if="openType === 2" style="margin: 20px 40px 0 0" :model="checkoutApplyCancelForm" :rules="checkoutApplyCancelRules" ref="checkoutApplyCancelForm" label-width="120px" class="demo-ruleForm">
      <el-form-item label="原因" prop="">
        <el-input type="textarea" :rows="2" v-model="checkoutApplyCancelForm.reason" placeholder="请输入原因"></el-input>
      </el-form-item>
    </el-form>
    <el-form v-if="openType === 3" style="margin: 20px 40px 0 0" :model="checkoutApproveForm" :rules="checkoutApproveRules" ref="checkoutApproveForm" label-width="120px" class="demo-ruleForm">
      <el-form-item label="退住时间" prop="leaveTime">
        <el-date-picker v-fixZoom style="width: 100%" v-model="checkoutApproveForm.leaveTime"
                        type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="xxxx-xx-xx xx:xx:xx" :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="备注" prop="">
        <el-input type="textarea" :rows="2" v-model="checkoutApproveForm.remark" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    <div style="height: 50px">
      <el-row style="margin: 0 20px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeCheckout()">
            <span>{{openType === 2 ? '关闭' : '取消'}}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div v-if="openType === 1" class="send-btn" @click="submitCheckoutApply('checkoutApplyForm')">
            <span>申请退住</span>
          </div>
          <div v-else-if="openType === 2" class="send-btn" @click="submitCheckoutApplyCancel('checkoutApplyCancelForm')">
            <span>取消退住</span>
          </div>
          <div v-else-if="openType === 3" class="send-btn" @click="submitCheckoutApprove('checkoutApproveForm')">
            <span>审批通过</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {
  accomodationcheckoutapply,
  accomodationcheckoutapplycancel,
  accomodationcheckoutapprove
} from '../../../api/yanglaoyuan/homebed'

export default {
  name: 'checkOut',
  model: {
    prop: 'checkOutShow',
    event: 'change'
  },
  props: {
    homeBedPersonObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      id: 0,
      eId: 0,
      epId: 0,
      espId: 0,
      espName: '',
      // 打开类型 1申请退住 2取消退住 3审核退住
      openType: 0,
      reasonArr: [{id: 1, name: '回家'}, {id: 2, name: '转往其他养老机构'}, {id: 3, name: '转入医疗机构'}, {id: 4, name: '死亡'}, {id: 5, name: '其他'}],
      pickerOptions: {
        // disabledDate (time) {
        //   return time.getTime() > Date.now()
        // }
      },

      checkoutApplyForm: {
        reason: '',
        remark: ''
      },
      checkoutApplyCancelForm: {
        reason: ''
      },
      checkoutApproveForm: {
        leaveTime: '',
        remark: ''
      },
      checkoutApplyRules: {
        reason: [{required: true, message: '请选择原因', trigger: 'change'}]
      },
      checkoutApplyCancelRules: {},
      checkoutApproveRules: {
        leaveTime: [{ required: true, message: '请选择退住时间', trigger: 'change' }]
      }
    }
  },
  created () {
    this.getStartData()
  },
  methods: {
    getStartData () {
      let loginResp = this.$store.state.user.LoginResp
      this.espId = loginResp.syspersonid
      this.espName = loginResp.personname

      this.openType = this.homeBedPersonObj.openType
      this.id = this.homeBedPersonObj.row.id
      this.eId = this.homeBedPersonObj.row.eid
      this.epId = this.homeBedPersonObj.row.epid

      if (this.openType === 3) {
        let now = new Date().format('yyyy-MM-dd hh:mm:ss')
        console.log(now)
        this.checkoutApproveForm.leaveTime = now
      }
    },

    closeCheckout () {
      this.$emit('change', false)
    },
    // 申请退住
    submitCheckoutApply (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            id: this.id,
            eid: this.eId,
            leavereason: this.checkoutApplyForm.reason,
            leaveremark: this.checkoutApplyForm.remark,
            leave_esp_id: this.espId,
            leave_esp_name: this.espName
          }
          accomodationcheckoutapply(data).then(res => {
            this.$notify({title: '成功', message: '成功申请退住', type: 'success', duration: 2000})
            this.$emit('updateTable')
            this.$emit('change', false)
          })
        }
      })
    },
    // 取消申请退住
    submitCheckoutApplyCancel (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            id: this.id,
            eid: this.eId,
            reason: this.checkoutApplyCancelForm.reason,
            leave_esp_id: this.espId,
            leave_esp_name: this.espName
          }
          accomodationcheckoutapplycancel(data).then(res => {
            this.$notify({title: '成功', message: '成功取消申请退住', type: 'success', duration: 2000})
            this.$emit('updateTable')
            this.$emit('change', false)
          })
        }
      })
    },
    // 审批退住
    submitCheckoutApprove (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            id: this.id,
            eid: this.eId,
            epid: this.epId,
            leave_audit_esp_id: this.espId,
            leave_audit_esp_name: this.espName,
            leave_time: this.checkoutApproveForm.leaveTime,
            leaveaudittime: '',
            leaveauditremark: this.checkoutApproveForm.remark
          }
          accomodationcheckoutapprove(data).then(res => {
            this.$notify({title: '成功', message: '成功审批退住', type: 'success', duration: 2000})
            this.$emit('updateTable')
            this.$emit('change', false)
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/checkOut.vue